import {
    SET_FLEET
} from '../constants/actions';

export const setFleet = (fleet) => ({
    type: SET_FLEET,
    fleet: fleet
});